// SCRUM-449 follow-up: math shared by the Event Ops "Signed up" funnel card
// and the percentage base every later card (RSVPs/Matched/Added to
// cart/Purchased) anchors on. Kept out of EventOps.jsx, which pulls in
// axios via Services/arndAPI.js and can't be imported into a Jest test here
// (see src/App.test.js's pre-existing ESM failure for the same reason).

/**
 * The funnel's real top: everyone who got at least as far as signing up
 * during this event — leads (signed up, not joined) plus everyone who
 * joined (RSVP'd). `null` while leads data hasn't loaded yet, mirroring the
 * card's own '—' placeholder for that case.
 */
export const signedUpCount = (leads, joinedParents) =>
  leads ? leads.count + joinedParents : null;

/**
 * Percentage base + label for every funnel card after "Signed up": QR
 * scans once wired, otherwise the cumulative Signed up number — exactly
 * how the old (pre-SCRUM-449) funnel's own "Parent signups" card anchored
 * every later stage.
 */
export const funnelBase = (f, leads) => {
  if (f.qrScans) return { base: f.qrScans.total, baseLabel: 'of scans' };
  const signedUp = signedUpCount(leads, f.joinedParents);
  return { base: signedUp ?? f.joinedParents, baseLabel: 'of signups' };
};
